import { BaseEntity, Default, Transform, toEntity } from './base';
import { NoteModel } from './note';

export class OpsUserModel extends BaseEntity {
  firstName?: string;
  lastName?: string;

  @Default(false)
  filler: boolean;

  @Default(false)
  provider: boolean;
  vip: boolean;
  firstTimeCustomer: boolean;
  marketer?: boolean;
  fleet: boolean;

  info: string;

  @Transform(toEntity(NoteModel))
  notes?: NoteModel[];
}

export interface UserParams {
  firstName?: string;
  lastName?: string;
  signupSource?: string;
  locationName?: string;
  locationDescription?: string;
  lat?: number;
  lng?: number;
  zipCode?: string;
  phone?: string;
  email?: string;
}

export interface UserUpdateParams {
  ref?: string;
  deepLinkData?: any;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  gmAuthCode?: string;
}



// WEBPACK FOOTER //
// ./src/models/user.ops.ts